const DEFAULT_AUTH_REDIRECT = '/my-account'

const AUTH_PATHS = [
  '/login',
  '/create-account',
  '/magic-login',
  '/reset-password',
  '/create-password'
]

const toPath = from => {
  if (!from) return null
  if (typeof from === 'string') return from
  if (typeof from.pathname === 'string') {
    return from.pathname + (from.search || '') + (from.hash || '')
  }
  return null
}

// Only same-app relative paths, so `?redirect=` cannot send users off-site.
export const sanitizeAuthRedirect = from => {
  const path = toPath(from)
  if (!path || path[0] !== '/' || path.startsWith('//') || path.includes('\\'))
    return null
  const pathname = path.split(/[?#]/)[0]
  if (AUTH_PATHS.some(p => pathname === p || pathname.startsWith(p + '/')))
    return null
  return path
}

// Router state is lost when the embed iframe reloads, so the destination is
// also carried in the `redirect` query param.
export const getPendingAuthRedirect = location =>
  sanitizeAuthRedirect(location?.state?.from) ||
  sanitizeAuthRedirect(
    new URLSearchParams(location?.search || '').get('redirect')
  )

export const getAuthRedirect = location =>
  getPendingAuthRedirect(location) || DEFAULT_AUTH_REDIRECT

export const authRoute = (pathname, from) => {
  const redirect = sanitizeAuthRedirect(from)
  if (!redirect) return { pathname }
  return {
    pathname,
    search: `?redirect=${encodeURIComponent(redirect)}`,
    state: { from: redirect }
  }
}

const SCHEDULE_PATHS = [
  '/class-schedule',
  '/class-detail',
  '/appointment',
  '/appointments',
  '/appointment-detail',
  '/courses',
  '/course'
]

// Where the user was heading when they created an account (for analytics).
export const getRegistrationSource = location => {
  const path = getPendingAuthRedirect(location)
  if (!path) return 'other'
  const pathname = path.split(/[?#]/)[0]
  const matches = prefix =>
    pathname === prefix || pathname.startsWith(prefix + '/')
  if (matches('/pricing')) return 'pricing'
  if (SCHEDULE_PATHS.some(matches)) return 'schedule'
  if (['/products', '/product-detail', '/cart'].some(matches)) return 'store'
  return 'other'
}
